import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import userSlice from 'src/reducers/userSlice';
import authReducer from 'src/reducers/authSlice';
import settingsReducer from 'src/reducers/settingsSlice';
import codeTableReducer from 'src/reducers/codeTableSlice';
import leaveFiltersReducer from 'src/reducers/leaveFiltersSlice';
import defectTrackerFiltersReducer from 'src/reducers/defectTrackerFiltersSlice';
import tenantConfigReducer from 'src/reducers/tenantConfigSlice';
import taskListFiltersReducer from 'src/reducers/taskListFiltersSlice';
import reportsReducer from 'src/reducers/reportsSlice';

export const store = configureStore({
  reducer: {
    users: userSlice,
    auth: authReducer,
    settings: settingsReducer,
    codeTables: codeTableReducer,
    leaveFilters: leaveFiltersReducer,
    defectTrackerFilters: defectTrackerFiltersReducer,
    tenantConfig: tenantConfigReducer,
    taskListFilters: taskListFiltersReducer,
    reports: reportsReducer,
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for use throughout the app
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
